import { UserRole } from '../enums';
import { User, UserDetails } from '../models';

const RESTRICTED_EMAIL_DOMAINS = [
  'alpha.school',
  'esports.school',
  'havruta.school',
  '2hourlearning.com',
  'sportsacademy.school',
  'nextgenacademy.school',
  'novatio.school',
  'novatio.academy',
  'unbound.school',
  'valenta.school',
  'waypointacademy.school',
];

export function isRestrictedEmail(email: string): boolean {
  return RESTRICTED_EMAIL_DOMAINS.some((domain: string) => email?.endsWith(domain));
}

export function isUserFromRestrictedDomain(userDetails: UserDetails): boolean {
  return !!userDetails?.email && isRestrictedEmail(userDetails.email);
}

export function isUserStudent(user: User): boolean {
  const groups: UserRole[] | undefined = user?.signInUserSession?.idToken?.payload['cognito:groups'];
  return groups ? groups.includes(UserRole.Student) : false;
}
